<button
  #button
  type="button"
  [disabled]="disabled()"
  [class]="buttonClasses()"
  [tabIndex]="disabled() ? -1 : 0"
  (click)="submit()"
>
  @if (iconLeft()) {
    <svg-icon [src]="iconLeft()" [svgClass]="iconClasses()"></svg-icon>
  }
  @if (label()) {
    <span>{{ label() }}</span>
  }
  @if (iconRight()) {
    <svg-icon [src]="iconRight()" [svgClass]="iconClasses()"></svg-icon>
  }
</button>
